const Sentry = require('@sentry/react');
const { logDevelopementEnv } = require('../constants/constants.json');

export const handleExcception = (error) => {
    const environment = process.env.REACT_APP_ENV;
    if (environment === 'development') {
        console.log(
            '%c !!!!!!!!!!!!!!!!!!!! Error Reported !!!!!!!!!!!!!!!!!!!! ',
            'background: #CCC; color: #FF0000'
        );
        console.log(error);
        if (logDevelopementEnv) {
            Sentry.captureException(error);
        }
    } else if (environment === 'production') {
        Sentry.captureException(error);
    }
};
